<template>
  <div class="dialogBox">
    <el-dialog :visible.sync="addActivevis" width="90%" center :show-close="false" :close-on-click-modal="false" @close="close">
      <el-row>
        <div class="box">
          <el-col :span="10" class="leftTable">
            <div class="leftTitle">通知名称</div>
            <!--<el-input v-model="searchValue" placeholder="请输入" class="input-with-select" size="mini" suffix-icon="el-icon-search" style="margin: 10px 0;" />-->
            <div style="height: 205px">
              <el-table :data="leftTableData" max-height="258" size="mini" :show-header="showHeader" style="width: 100%" :header-cell-style="tableHeaderColor" @selection-change="checkAll">
                <el-table-column type="selection" width="50" />
                <el-table-column prop="name" label="通知名称" />
              </el-table>
            </div>
          </el-col>
          <el-col :span="4" class="btnMove">
            <div>
              <div class="opSetting" @click="handelSelect">
                <el-button icon="el-icon-d-arrow-right" :disabled="nowSelectData.length?false:true" size="mini" type="primary" />
              </div>
              <div class="spacing" @click="handleRemoveSelect">
                <el-button icon="el-icon-d-arrow-left" :disabled="nowSelectRightData.length?false:true" size="mini" type="primary" />
              </div>
            </div>
          </el-col>
          <el-col :span="10" class="leftTable">
            <div style="background-color: #fff;height: 290px;">
              <el-table :data="rightTableData" max-height="290" size="mini" :header-cell-style="tableHeaderColor" @selection-change="checkRightAll">
                <el-table-column type="selection" width="50" />
                <el-table-column prop="name" label="通知名称" width="150" />
                <el-table-column prop="label" label="通知方式">
                  <template slot-scope="scope">
                    <el-select v-model="selectCode[scope.row.name]" multiple collapse-tags size="mini" placeholder="请选择" @change="selectInput(scope.row.name)">
                      <el-option
                        v-for="(item, i) in methodList"
                        :key="i"
                        :label="item.name"
                        :value="item.name"
                      />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="role" label="通知角色">
                  <template slot-scope="scope">
                    <el-select v-model="selectDataList[scope.row.name]" size="mini" placeholder="请选择" @change="selectUnit(scope.row.name)">
                      <el-option
                        v-for="item in unitList"
                        :key="item"
                        :label="item"
                        :value="item"
                      />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="role">
                  <template slot-scope="scope">
                    <el-select v-model="selectRoleList[scope.row.name]" size="mini" placeholder="请选择" @change="selectRole(scope.row.name)">
                      <el-option
                        v-for="item in roleList"
                        :key="item"
                        :label="item"
                        :value="item"
                      />
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </div>
      </el-row>
      <div class="footer">
        <span slot="footer" class="dialog-footer">
          <el-button v-preventReClick type="primary" size="mini" @click="submit">确 定</el-button>
          <el-button size="mini" @click="cancel">取 消</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getProjectId } from '@/utils/auth'
import { importUser } from '@/api/proUser'
import { inInfo } from '@/api/info'
export default {
  name: 'InfoImport',
  props: {
    visiable: {
      type: Boolean
    },
    leftData: {
      type: Array
    },
    dataUser: {
      type: Array

    },
    unitAllList: {
      type: Array
    },
    allRoleList: {
      type: Array
    }
  },
  data() {
    return {
      addActivevis: false,
      value: [1],
      roleValue: [],
      selectVal: '',
      proId: '',
      tableData: [],
      showHeader: false, // 是否显示表头
      searchValue: '', // 搜索值
      leftTableData: [], // 左边表格数据
      rightTableData: [], // 右边表格数据
      nowSelectData: [], // 左边选中列表数据
      nowSelectRightData: [], // 右边选中列表数据
      selectDataList: [], // 下拉框选中的值
      selectCode: [],
      selectRoleList: [],
      unitAllLists: [
      ],
      code: '',
      allUserList: [],
      methodList: [
        { name: '站内通知' },
        { name: '邮件通知' }
      ],
      unitList: [
        '关联单位',
        '所有单位',
        '申办方'
      ],
      roleList: []
    }
  },
  watch: {
    visiable(newVal) {
      this.addActivevis = newVal
    },
    'leftData': function() {
      this.leftTableData = this.leftData
    },
    'dataUser': function() {
      this.allUserList = this.dataUser
    },
    'unitAllList': function() {
      this.unitAllLists = this.unitAllList
    },
    allRoleList: function() {
      this.roleList = this.allRoleList
    }
  },
  created() {
    this.proId = getProjectId()
  },
  methods: {
    close() {
      this.addActivevis = false
      this.$emit('dialogHide')
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) { // 改表头颜色
      if (rowIndex === 0) {
        return 'background-color: #D6E4FF;color: #666;'
      }
    },
    checkAll(val) {
      this.nowSelectData = val
    },
    checkRightAll(val) {
      this.nowSelectRightData = val
    },
    // 移除
    handelSelect() {
      this.rightTableData = this.handleConcatArr(this.rightTableData, this.nowSelectData)
      this.handleRemoveTabList(this.nowSelectData, this.leftTableData)
      this.nowSelectData = []
    },
    // 添加
    handleRemoveSelect() {
      this.leftTableData = this.handleConcatArr(this.leftTableData, this.nowSelectRightData)
      this.handleRemoveTabList(this.nowSelectRightData, this.rightTableData)
      this.nowSelectRightData = []
    },
    selectRole(name) {
      this.rightTableData.map(item => {
        if (item.name === name) {
          item.role = this.selectRoleList[name]
          console.log(88888)
          console.log(item.role)
        }
      })
    },
    selectUnit(name) {
      console.log(name)
      this.rightTableData.map(item => {
        if (item.name === name) {
          item.unit_type = this.selectDataList[name]
          console.log(item.unit_type)
        }
      })
    },
    selectInput(name) {
      console.log(name)
      this.rightTableData.map(item => {
        console.log(name)
        if (item.name === name) {
          item.method = this.selectCode[name]
          console.log(item.method)
        }
      })
    },
    handleConcatArr(a, b) {
      let arr = []
      arr = arr.concat(a, b)
      return arr
    },
    handleRemoveTabList(isNeedArr, originalArr) {
      if (isNeedArr.length && originalArr.length) {
        for (let i = 0; i < isNeedArr.length; i++) {
          for (let k = 0; k < originalArr.length; k++) {
            if (isNeedArr[i] === originalArr[k]) {
              originalArr.splice(k, 1)
            }
          }
        }
        // isNeedArr.map(item => {
        //   console.log('我是谁')
        //   console.log(item.receiver_role_list)
        //   this.selectCode[item.name] = item.method
        //   this.selectDataList[item.name] = item.receiver_role_list.map(i => {
        //     console.log(i)
        //     console.log(i.unit_type)
        //     return i.unit_type
        //   })
        //   this.selectRoleList[item.name] = item.receiver_role_list.map(a => {
        //     return a.role_str
        //   })
        // })
      }
    },
    validate() {
      if (!this.rightTableData || this.rightTableData.length === 0) {
        this.$message({
          type: 'warning',
          message: '请选择通知名称!'
        })
        return false
      }
      const booleanRoles = this.rightTableData.some(item => item.unit_type === null || item.unit_type === '' || item.unit_type === undefined)
      const booleanUnit = this.rightTableData.some(item => item.method === null || item.method === '' || item.method === undefined || item.unit.method <= 0)
      if (booleanRoles) {
        this.$message({
          type: 'warning',
          message: '请选择角色!'
        })
        return false
      }
      if (booleanUnit) {
        this.$message({
          type: 'warning',
          message: '请选择通知角色!'
        })
        return false
      }
      return true
    },

    submit() {
      if (1) {
        const o = this.rightTableData.map(item => {
          console.log(999)
          console.log(item)
          const obj = {}
          obj.name = item.name
          obj.method = item.method
          const receiver_role = {}
          // receiver_role_list.unit_type = item.unit_type
          // receiver_role_list.role_str = item.role
          obj['receiver_role'] = receiver_role
          obj['receiver_role'].unit_type = item.unit_type
          obj['receiver_role'].role_str = item.role
          return obj
        })
        const params = {
          project_id: this.proId,
          msg_list: o
        }
        inInfo(params).then(res => {
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: 'success'
            })
            this.cancel()
          } else {
            this.$message(res.msg)
          }
        }).catch(res => {
          console.log(res.msg)
        })
      }
    },
    cancel() {
      this.nowSelectData = []
      this.rightTableData = []
      this.selectDataList = []
      this.selectCode = []
      this.addActivevis = false
      this.$parent.getInfoList()
    }
  }
}
</script>

<style lang="scss">
  .box{
    .tableBox {
      width: 100%;
      height: 300px;
      overflow-y: scroll;
    }
  }
  .dialogBox{
    .footer{
      text-align: center;
      margin-top: 30px;
    }
    .leftTable{
      background-color: #F0F5FF;
      padding: 5px;
      min-height: 300px;
      .leftTitle{
        text-align: center;
        font-size: 12px;
        color: #595959;
        font-weight: bold;
        background-color: #D6E4FF;
        padding: 10px 0;
      }
    }
    .btnMove{
      margin-top: 10%;
      text-align: center;
      .opSetting{
        margin: 10px 0;
      }
    }
    .transferBox{
      min-height: 300px;
      .el-transfer{
        .el-transfer-panel{
          width: 358px!important;
        }
      }
    }
  }
</style>
<style scoped>
  /deep/ .leftTable:last-child{
    width: 63%;
  }
  /deep/ .leftTable:first-child {
    width: 20%;

  }
</style>
